import { render, staticRenderFns } from "./notarizationDetail.vue?vue&type=template&id=0904fb82"
import script from "./notarizationDetail.vue?vue&type=script&lang=js"
export * from "./notarizationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports